module.exports = new __parcel__URL__("news05.3a1ac88e.jpg").toString();